export enum SortingMenuTypes {
    CameraSettingsTab,
    DetectionSettingsTab,
    SortingSettingsTab,
    ProductionTab,
}